import { BusinessInfo } from '../../domain/BusinessInfo';

export const BusinessInfolMap = {
  toPersistence: (businessInfo: BusinessInfo) => ({
    name: businessInfo.name,
    identifier: businessInfo.identifier,
    countryId: businessInfo.countryId,
  }),
};
